export enum CancellationReason {
  ManualCancelation = 1,
  DeliveryZoneDeactivated = 2,
  BlockedDeliverySlotes = 3
}

export const CancellationReasonName: Record<CancellationReason, string> = {
  [CancellationReason.ManualCancelation]: 'ManualCancelation',
  [CancellationReason.DeliveryZoneDeactivated]: 'DeliveryZoneDeactivated',
  [CancellationReason.BlockedDeliverySlotes]: 'BlockedDeliverySlotes'
};
